import packageCardV2Utils from '../utils/packageCardV2Utils';
import browserUtils, { getUrlParamsMapV2 } from '../utils/browserUtils';
import { AFFILIATE_CONFIG, PACKAGE_BASE_PATH } from '../constants/appConstant';
import { checkIfAffiliateIsValid } from '../src/utils/utils';
import { getMMT_HLD_OBJ, getAffiliateDetails } from '../utils/appUtils';
import { CARD_TYPE, GROUP_COLLECTION_VIEW_TYPE } from '../constants/packageConstants';
import { convertRoomForUrl } from '../utils/formattingUtils';
import { getISTTime } from '../utils/packageUtils';
import { THEMES_FILTER_ID } from '../../dynamicDetails_v3/src/constants';

const getActivitiesAttractions = activityDetails =>
  (activityDetails.activities &&
    activityDetails.activities
      .filter(activity => !!activity.metaName)
      .map(activity => activity.metaName)) ||
  [];

const getFormattedSmeDetails = genreDetails => {
  if (genreDetails) {
    return {
      genreType: genreDetails[0]?.genreType,
      genreImageURL: genreDetails[0]?.genreImageURL,
      image: genreDetails[0]?.images.RAW,
    };
  }
  return {};
};

const getFormattedSightSeeingDetail = sightSeeingDetails => {
  if (sightSeeingDetails) {
    let str = '';
    sightSeeingDetails.forEach(detail => {
      str = str.concat(` •${detail.name}`);
    });
    return str;
  }
};
export const getPackageCardDataL3 = (holidayPackage, seoFilters = {}) => {
  const {
    cardType,
    id,
    name,
    noOfNights,
    imageUrl,
    deepLink,
    position,
    listingPricingDetails,
    packageDetailDeepLink,
  } = holidayPackage;
  if (cardType === CARD_TYPE.CONTENT) {
    return {
      cardType,
      id,
      imageUrl,
      deepLink,
      position,
    };
  }
  const { priceInfo = [] } = listingPricingDetails || {};
  const price = priceInfo?.[0]?.[0]?.text;
  let cardTypeValue = cardType;
  if (!cardType) {
    cardTypeValue = 'Package';
  }
  let updatedName = name;
  const MMT_HLD = getMMT_HLD_OBJ();
  if (MMT_HLD.fromSEO) {
    const { themes, depCity } = seoFilters;

    if (themes) {
      updatedName += ` ${themes} Package`;
    } else {
      updatedName += ' Package';
    }

    if (depCity) {
      updatedName += ` From ${depCity}`;
    }
  }

  return {
    cardType: cardTypeValue,
    id,
    name: updatedName,
    duration: packageCardV2Utils.getFormattedDurationText(noOfNights),
    price,
    url: packageDetailDeepLink,
  };
};

export const getPackageCardData = (
  holidayPackage,
  seoFilters = {},
  hostName = '',
  appliedFilters = []
) => {
  const {
    cardType,
    id,
    imageUrl,
    deepLink,
    position,
    name,
    usp,
    nights,
    destinationDetails,
    categoryDetails,
    priceDetails,
    packageType,
    departureDetails,
    activityDetails,
    inclusionDetails,
    imageDetails,
    listingStaticData,
    safe,
    packageSynopsis,
    persuasions,
    genreDetails,
    smeDetail,
    commuteDetails,
    storyEnabled,
    bundled,
    tagDetails,
    visaDetails,
    collectionType = '',
    hotelDetails,
    listingPackageVariantsDetails,
    description,
    paxInfo,
    mcatList,
    requestMeta,
  } = holidayPackage;
  if (cardType === CARD_TYPE.CONTENT) {
    return {
      cardType,
      id,
      imageUrl,
      deepLink,
      position,
    };
  }
  const { defaultCategoryId } = categoryDetails;
  const defaultCategoryPrice = priceDetails.categoryPrices
    .filter(priceObj => Number(priceObj.categoryId) === defaultCategoryId)
    .pop();
  const currentPageQueryParams = getUrlParamsMapV2();
  const affiliateDetails = hostName === '' ? getAffiliateDetails() : AFFILIATE_CONFIG[hostName];
  const baseUrl = hostName === '' ? '' : affiliateDetails.baseUrl;
  const version = bundled || false;
  const room = paxInfo && convertRoomForUrl(paxInfo);
  const dateRegEx = new RegExp(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/);

  const queryParamObj = {
    id,
    listingClassId: defaultCategoryId,
    pkgType: packageType,
    fromCity: departureDetails.cityName,
    defaultPageForOnlineBookableFIT: true,
    cmp: currentPageQueryParams.cmp,
    intid: currentPageQueryParams.intid,
    affiliate: affiliateDetails.affiliateIdentifier,
    ...requestMeta,
    room,
  };
  const themeFilters = appliedFilters?.find(filter => filter.id === THEMES_FILTER_ID);
  let mcat = [];
  if (currentPageQueryParams.mcat) {
    mcat = currentPageQueryParams.mcat?.split(',');
  }
  if (themeFilters?.values?.length) {
    mcat = [...mcat, ...themeFilters?.values];
  }

  if (mcatList?.length) {
    mcat = [...mcat, ...mcatList];
  }

  mcat = [...new Set(mcat)];

  queryParamObj.mcat = mcat.join(',');
  if (currentPageQueryParams.banner) {
    queryParamObj.banner = currentPageQueryParams.banner;
  }
  if (
    currentPageQueryParams?.dateSearched &&
    dateRegEx.test(currentPageQueryParams?.dateSearched)
  ) {
    queryParamObj.searchDate = currentPageQueryParams.dateSearched.split('/').reverse().join('-');
  }
  if (currentPageQueryParams?.glp) {
    queryParamObj.glp = currentPageQueryParams?.glp;
  }
  if (room) queryParamObj.room = room;
  if (/[0-9]{13}/.test(defaultCategoryPrice.departureDate)) {
    const date = new Date(defaultCategoryPrice.departureDate);
    queryParamObj.depDate = browserUtils.dateFormatter(getISTTime(date), 'YYYY-MM-DD');
  } else {
    queryParamObj.depDateMilliSec = defaultCategoryPrice.departureDate;
  }
  const MMT_HLD = getMMT_HLD_OBJ();
  if (version) {
    queryParamObj.version = 3;
  }
  if (checkIfAffiliateIsValid()) {
    queryParamObj.aff = MMT_HLD.aff;
  }
  if (MMT_HLD?.showStory && storyEnabled) {
    queryParamObj.story = true;
  }
  if (MMT_HLD?.fromSEO && queryParamObj.cmp === undefined) {
    queryParamObj.intid = 'Seo_DOM_Holiday_pkg_name_click';
  }
  if (currentPageQueryParams.source) {
    queryParamObj.source = currentPageQueryParams.source;
  }
  const { couponDiscount = {} } = defaultCategoryPrice;
  const { couponCode = '', additionalDiscountDetail = {} } = couponDiscount;
  let limitedTimeDeal = false;
  let couponEndTime = null;
  if (couponCode.startsWith('DEALOF')) {
    const { limitedTimeDeal: limitedTime, couponEndTime: endTime } = additionalDiscountDetail;
    limitedTimeDeal = limitedTime;
    couponEndTime = endTime;
  }
  let cardTypeValue = cardType;
  if (!cardType) {
    cardTypeValue = 'Package';
  }
  let persuasionsArr = persuasions;
  if (!persuasions) {
    persuasionsArr = [];
  }

  let updatedName = name;
  if (MMT_HLD.fromSEO) {
    const { themes, depCity } = seoFilters;

    if (themes) {
      updatedName += ` ${themes} Package`;
    } else {
      updatedName += ' Package';
    }

    if (depCity) {
      updatedName += ` From ${depCity}`;
    }
  }

  const checkListingStaticData = {
    onlineDeal: false,
    premium: false,
    componentTags: {},
    packageType: {},
    ...listingStaticData,
  };
  let collectionCardData = {};
  if (collectionType === GROUP_COLLECTION_VIEW_TYPE.HOTELVIEW) {
    const { categories = [] } = hotelDetails || {};
    const requiredHotel = categories.find(category => category?.categoryId === defaultCategoryId);
    if (requiredHotel) {
      const { hotels = [] } = requiredHotel;
      collectionCardData = {
        ...collectionCardData,
        hotelInfo: hotels[0] || {},
      };
    }
  } else if (collectionType === GROUP_COLLECTION_VIEW_TYPE.ACTIVITYVIEW) {
    const { categories = [] } = categoryDetails || {};
    const categoryName =
      categories.find(category => category?.id === defaultCategoryId)?.name || '';
    collectionCardData = {
      categoryName,
    };
  }

  return {
    cardType: cardTypeValue,
    id,
    name: updatedName,
    usp,
    image: packageCardV2Utils.getImage(imageDetails.mainImage, MMT_HLD.fromSEO),
    duration: packageCardV2Utils.getFormattedDurationText(nights),
    destinationWiseDuration: destinationDetails.destinations,
    attractions: getActivitiesAttractions(activityDetails),
    included: packageCardV2Utils.getIncludedLobs(inclusionDetails),
    price: {
      actual: defaultCategoryPrice.price,
      discounted: defaultCategoryPrice.discountedPrice || defaultCategoryPrice.slashedPrice,
    },
    url: `${baseUrl}${PACKAGE_BASE_PATH}?${browserUtils.getQueryStr(queryParamObj)}`,
    isPremium: listingStaticData?.premium || false,
    limitedTimeDeal,
    safe,
    sightSeeingDetails: getFormattedSightSeeingDetail(commuteDetails?.sightSeeingDetails),
    persuasions: persuasionsArr,
    packageSynopsis,
    genreDetails: getFormattedSmeDetails(genreDetails),
    smeDetail,
    listingStaticData: checkListingStaticData,
    tagDetails,
    sightSeeingList: commuteDetails?.sightSeeingDetails,
    departureDetails,
    inclusionDetails,
    visaDetails: visaDetails.visas[0],
    description,
    hotelDetails,
    variantsDetails: listingPackageVariantsDetails,
    priceDetails,
    queryParamObj,
    defaultCategoryId,
    bundled,
    rooms: room,
    ...collectionCardData,
  };
};
